import type { SVGProps } from "react";

export function CoachAvatarFallbackSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <circle cx="12" cy="9" r="4.5" fill="currentColor" />
      <path d="M3 24V22.5a9 9 0 0 1 18 0V24Z" fill="currentColor" />
    </svg>
  );
}
